import { RichText } from '@/webapp/src/components/other/RichText/index.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Segment, Segments } from '@/webapp/src/lib/uninty.components.js'

export const DappInfoComponent = () => {
  return (
    <Segments>
      <Segment title="Скачайте СтрахоБот" size="m">
        <SectionWrapper
          useQuery={() => trpc.getDappInfo.useQuery()}
          setProps={({ queryResult, ctx }) => ({
            dappInfo: queryResult.data.dappInfo,
            sourceVersion: ctx.env.SOURCE_VERSION,
          })}
        >
          {({ dappInfo, sourceVersion }) => {
            return (
              <RichText>
                <p>
                  <a href={dappInfo.downloadUrls.win32x64}>Скачать для Windows</a>
                </p>
                <p>
                  <a href={dappInfo.downloadUrls.darwinarm64}>Скачать для macOS ARM64</a> — маки на процессоре M1 и
                  старше
                </p>
                <p>
                  <a href={dappInfo.downloadUrls.darwinx64}>Скачать для macOS x64</a> — маки про на процессоре Intel
                </p>
              </RichText>
            )
          }}
        </SectionWrapper>
      </Segment>
      <Segment title="Инструкция по установке на Windows" size="m">
        <RichText>
          <ol>
            <li>
              Скачайте файл с программой <code>strahobot.exe</code>
            </li>
            <li>Запустите этот файл</li>
            <li>Вас предупредят об опасности скачанного файла. И будет кнопка "Закрыть". Не нажимайте на неё.</li>
            <li>Нажмите на незаметную ссылку "Подробнее"</li>
            <li>Нажмите "Запустить всё равно"</li>
            <li>Пользуйтесь.</li>
          </ol>
        </RichText>
      </Segment>
      <Segment title="Инструкция по установке на macOS" size="m">
        <RichText>
          <ol>
            <li>Скачайте скаченный zip-архив с приложением.</li>
            <li>
              Распакуйте его. Там внутри файл с приложением <code>strahobot.app</code>
            </li>
            <li>
              Обязательно переместите приложение <code>strahobot.app</code> в папку <code>Applications</code>, чтобы
              работало автоматическое обновление.
            </li>
            <li>Откройте приложение и пользуйтесь.</li>
            {/* <li>
              Откройте программу <code>Terminal</code>.
            </li>
            <li>
              Туда скопируйте и вставьте команду:
              <pre>
                <code>xattr -r -d com.apple.quarantine</code>
              </pre>
            </li>
            <li>Поставьте пробле после команды</li>
            <li>Пертащите распакованный файл в окно терминала, чтобы в строку подставил путь к этому файлу</li>
            <li>
              Получится что-то вроде этого:
              <pre>
                <code>xattr -r -d com.apple.quarantine /Users/superman/Downloads/strahobot.app</code>
              </pre>
            </li>
            <li>Нажмите Enter</li>
            <li>
              Можете кинуть приложение в папку <code>Applications</code>. А можете оставить его где угодно.
            </li>
            <li>Откройте приложение и пользуйтесь.</li>
            <li>
              Не расстраивайтесь. Однажды мы получим сертификаты, и всё будет установливаться нормально, но пока вот
              так.
            </li> */}
          </ol>
        </RichText>
      </Segment>
      <SectionWrapper
        useQuery={() => trpc.getDappInfo.useQuery()}
        setProps={({ queryResult, ctx }) => ({
          dappInfo: queryResult.data.dappInfo,
          sourceVersion: ctx.env.SOURCE_VERSION,
        })}
      >
        {({ dappInfo, sourceVersion }) => {
          return (
            <div style={{ color: '#fff' }}>
              Текущая версия сервера: {sourceVersion}
              <br />
              Актуальная версия программы: {dappInfo.version}
            </div>
          )
        }}
      </SectionWrapper>
    </Segments>
  )
}
